import { __awaiter } from "tslib";
import * as React from 'react';
import { AlertCircle } from 'react-feather';
import { withRouter } from 'react-router-dom';
import GistSelectWidget from '../../gist-select-widget';
import './index.css';
import { parse as parseJSONC } from 'jsonc-parser';
class GistModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            gist: {
                filename: '',
                image: '',
                imageStyle: {
                    bottom: 0,
                },
                revision: '',
                type: props.mode,
                url: '',
            },
            gistLoadClicked: false,
            invalidFilename: false,
            invalidRevision: false,
            invalidUrl: false,
            latestRevision: false,
            syntaxError: false,
        };
    }
    updateGist(gist) {
        this.setState({
            gist: Object.assign(Object.assign({}, this.state.gist), gist),
        });
    }
    updateGistUrl(event) {
        this.updateGist({ url: event.currentTarget.value });
        this.setState({
            invalidUrl: false,
        });
    }
    updateGistRevision(event) {
        this.updateGist({ revision: event.currentTarget.value });
        this.setState({
            invalidRevision: false,
        });
    }
    updateGistFile(event) {
        this.updateGist({ filename: event.currentTarget.value });
        this.setState({
            invalidFilename: false,
        });
    }
    onSelectGist(closePortal) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.state.gist.url.trim().toLowerCase();
            this.setState({
                gist: Object.assign(Object.assign({}, this.state.gist), { filename: this.state.gist.filename.trim(), revision: this.state.gist.revision.trim().toLowerCase() }),
            });
            if (url.length === 0) {
                this.refGistForm.reportValidity();
                return;
            }
            this.setState({
                gistLoadClicked: true,
            });
            let gistUrl;
            if (url.match(/gist\.githubusercontent\.com/)) {
                gistUrl = new URL(url, 'https://gist.githubusercontent.com');
                const [revision, filename] = gistUrl.pathname.split('/').slice(4);
                this.setState({
                    gist: Object.assign(Object.assign({}, this.state.gist), { filename,
                        revision }),
                });
            }
            else if (url.match(/gist\.github\.com/)) {
                gistUrl = new URL(url, 'https://gist.github.com');
            }
            const gistId = gistUrl.pathname.split('/')[2];
            try {
                const gistCommitsResponse = yield fetch(`https://api.github.com/gists/${gistId}/commits`);
                this.setState({
                    invalidUrl: !gistCommitsResponse.ok,
                });
                const gistCommits = yield gistCommitsResponse.json();
                if (!this.state.gist.revision && !this.state.invalidUrl) {
                    this.setState({
                        gist: Object.assign(Object.assign({}, this.state.gist), { revision: gistCommits[0].version }),
                    });
                }
                else if (this.state.invalidUrl) {
                    this.setState({
                        gistLoadClicked: false,
                    });
                    throw new Error('Invalid Gist URL');
                }
                if (gistCommits[0].version === this.state.gist.revision) {
                    this.setState({
                        latestRevision: true,
                    });
                }
                const gistSummaryResponse = yield fetch(`https://api.github.com/gists/${gistId}/${this.state.gist.revision}`);
                this.setState({
                    invalidRevision: !gistSummaryResponse.ok,
                });
                const gistSummary = yield gistSummaryResponse.json();
                if (this.state.invalidRevision) {
                    this.setState({
                        gistLoadClicked: false,
                    });
                    throw new Error('Invalid Revision');
                }
                else if (!this.state.invalidRevision && this.state.gist.filename === '') {
                    const jsonFiles = Object.keys(gistSummary.files).filter((file) => {
                        if (file.split('.').slice(-1)[0] === 'json') {
                            return true;
                        }
                    });
                    if (jsonFiles.length === 0) {
                        this.setState({
                            gistLoadClicked: false,
                            invalidUrl: true,
                        });
                        throw new Error('No JSON file exists in the gist');
                    }
                    else {
                        this.setState({
                            gist: Object.assign(Object.assign({}, this.state.gist), { filename: jsonFiles[0] }),
                        }, () => {
                            const { revision, filename } = this.state.gist;
                            parseJSONC(gistSummary.files[jsonFiles[0]].content);
                            if (this.state.latestRevision) {
                                this.props.history.push(`/gist/${gistId}/${filename}`);
                            }
                            else {
                                this.props.history.push(`/gist/${gistId}/${revision}/${filename}`);
                            }
                            closePortal();
                        });
                    }
                }
                else {
                    if (gistSummary.files[this.state.gist.filename] === undefined) {
                        this.setState({
                            gistLoadClicked: false,
                            invalidFilename: true,
                        });
                        throw new Error('Invalid file name');
                    }
                    const rawResponse = yield fetch(gistSummary.files[this.state.gist.filename].raw_url); // fetch from raw_url to handle large files
                    const errors = [];
                    parseJSONC(yield rawResponse.text(), errors);
                    if (errors.length > 0)
                        throw SyntaxError; // check if the loaded file is a JSON
                    const { revision, filename } = this.state.gist;
                    if (this.state.latestRevision) {
                        this.props.history.push(`/gist/${gistId}/${filename}`);
                    }
                    else {
                        this.props.history.push(`/gist/${gistId}/${revision}/${filename}`);
                    }
                    closePortal();
                }
            }
            catch (error) {
                if (error instanceof SyntaxError) {
                    this.setState({
                        gistLoadClicked: false,
                        syntaxError: true,
                    });
                }
            }
        });
    }
    preview(id, file, image) {
        this.setState({
            gist: Object.assign(Object.assign({}, this.state.gist), { filename: file, image, imageStyle: Object.assign(Object.assign({}, this.state.gist.imageStyle), { bottom: 0 }), revision: '', url: `https://gist.github.com/${this.props.handle}/${id}` }),
            invalidFilename: false,
            invalidRevision: false,
            invalidUrl: false,
            syntaxError: false,
        });
    }
    slideImage(event) {
        const imageHeight = event.target.height;
        this.setState({
            gist: Object.assign(Object.assign({}, this.state.gist), { imageStyle: Object.assign(Object.assign({}, this.state.gist.imageStyle), { bottom: imageHeight > 100 ? imageHeight - 100 : 0 }) }),
        });
    }
    slideImageBack() {
        this.setState({
            gist: Object.assign(Object.assign({}, this.state.gist), { imageStyle: Object.assign(Object.assign({}, this.state.gist.imageStyle), { bottom: 0 }) }),
        });
    }
    render() {
        return (React.createElement("div", null,
            React.createElement("h1", null,
                "Load",
                ' ',
                React.createElement("a", { href: "https://gist.github.com/", target: "_blank", rel: "noopener noreferrer" }, "GitHub Gist")),
            React.createElement("div", { className: "gist-split" },
                React.createElement("div", { className: "personal-gist" },
                    React.createElement("h3", null, "Your gists"),
                    React.createElement("p", null,
                        "To load a gist, select it in the list below or specify its details on the right. View all your Gists on",
                        ' ',
                        React.createElement("a", { href: `https://gist.github.com/${this.props.handle}` }, "GitHub"),
                        "."),
                    React.createElement(GistSelectWidget, { selectGist: this.preview.bind(this) })),
                React.createElement("div", { className: "load-gist" },
                    React.createElement("h3", null, "Load gists"),
                    React.createElement("form", { ref: (form) => (this.refGistForm = form) },
                        React.createElement("div", { className: "gist-input-container" },
                            React.createElement("label", null,
                                "Gist URL",
                                React.createElement("div", { style: { marginTop: '2px' } },
                                    React.createElement("small", null,
                                        "Example:",
                                        ' ',
                                        React.createElement("span", { className: "gist-url", onClick: (e) => this.setState({
                                                gist: Object.assign(Object.assign({}, this.state.gist), { filename: '', image: '', revision: '', url: 'https://gist.github.com/domoritz/455e1c7872c4b38a58b90df0c3d7b1b9' }),
                                            }) }, 'https://gist.github.com/domoritz/455e1c7872c4b38a58b90df0c3d7b1b9'))),
                                React.createElement("input", { required: true, className: "gist-input", type: "text", placeholder: "Enter URL", value: this.state.gist.url, onChange: this.updateGistUrl.bind(this) })),
                            React.createElement("div", { className: "error-message" }, this.state.invalidUrl && React.createElement("span", null, "Please enter a valid URL."))),
                        React.createElement("div", { className: "gist-optional" },
                            React.createElement("div", { className: "gist-input-container gist-optional-input-container" },
                                React.createElement("label", null,
                                    "Revision (optional)",
                                    React.createElement("input", { className: "gist-input", type: "text", placeholder: "Enter revision", value: this.state.gist.revision, onChange: this.updateGistRevision.bind(this) })),
                                React.createElement("div", { className: "error-message" }, this.state.invalidRevision && React.createElement("span", null, "Please enter a valid revision."))),
                            React.createElement("div", { className: "gist-input-container gist-optional-input-container" },
                                React.createElement("label", null,
                                    "Filename (optional)",
                                    React.createElement("input", { className: "gist-input", type: "text", placeholder: "Enter filename", value: this.state.gist.filename, onChange: this.updateGistFile.bind(this) })),
                                React.createElement("div", { className: "error-message" }, this.state.invalidFilename ? (React.createElement("span", null, "Please enter a valid JSON file")) : (this.state.syntaxError && React.createElement("span", null, "JSON is syntactically incorrect"))))),
                        this.state.gist.url && this.state.gist.filename ? (this.state.gist.image ? (React.createElement("div", { className: "preview-container" },
                            React.createElement("div", { className: "preview-text" }, "Preview:"),
                            React.createElement("div", { className: "preview-image-container" },
                                React.createElement("div", { className: "preview-image-wrapper" },
                                    React.createElement("img", { src: this.state.gist.image, onMouseOver: this.slideImage.bind(this), onMouseOut: this.slideImageBack.bind(this), style: {
                                            transform: `translateY(-${this.state.gist.imageStyle.bottom}px)`,
                                        } }))))) : (React.createElement("div", { className: "preview-error-message-container" },
                            React.createElement("div", { className: "preview-error-message" },
                                React.createElement(AlertCircle, { className: "preview-error-icon" }),
                                React.createElement("span", null, "No preview available for this gist file.")),
                            React.createElement("span", { className: "preview-error-fix" },
                                "Upload an image file with name ",
                                this.state.gist.filename.replace(/\.json/i, '.(png/jpg)'),
                                ".")))) : (React.createElement(React.Fragment, null)),
                        React.createElement("button", { type: "button", onClick: () => this.onSelectGist(this.props.closePortal) }, this.state.gistLoadClicked ? 'Loading..' : 'Load'))))));
    }
}
export default withRouter(GistModal);
